import { apiClient } from './api';
import { AnalyticsData, AnalyticsOut, LinkedAgent } from '../types';

export const analyticsApi = {
  // New analytics endpoint with empty state support
  getAnalytics: async (agentIds?: string[]): Promise<AnalyticsOut> => {
    const params = agentIds && agentIds.length > 0 ? { agent_ids: agentIds.join(',') } : {};
    return apiClient.get<AnalyticsOut>('/api/analytics', { params });
  },

  // Legacy analytics endpoint for backward compatibility
  getAnalyticsLegacy: async (): Promise<AnalyticsData> => {
    return apiClient.get<AnalyticsData>('/api/analytics/legacy');
  },

  // Get linked agents
  getLinkedAgents: async (): Promise<LinkedAgent[]> => {
    return apiClient.get<LinkedAgent[]>('/api/linked-agents');
  },

  // Unlink agent
  unlinkAgent: async (id: string, type: 'assistant' | 'workflow'): Promise<{ success: boolean }> => {
    return apiClient.post<{ success: boolean }>('/api/unlink-agent', { id, type });
  },
};